<script lang="ts" setup>

//vue
import { onMounted, reactive, watch } from "vue";

//servicos
import config from "@/app.config.json";
import * as service from "@/services/clientesContratosService";
import * as mensalidadesService from "@/services/mensalidadesService";
import * as paramsService from "@/services/paramsService";
import { fdata, fdataUS, fdataUSS, f2dec, isoParaData } from "@/utils/funcoes";
import { useAcl } from "vue-simple-acl";
const acl = useAcl();

//componentes
import TrataTecla from "@/components/TrataTecla/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
import DropdownPlanos from "@/components/Dropdowns/DropdownPlanos.vue";
import DropdownSimNao from "@/components/Dropdowns/DropdownSimNao.vue";
import DropdownContratosStatus from "@/components/Dropdowns/DropdownContratosStatus.vue";

interface IProps {
  ClienteId?: number
}

var props = defineProps<IProps>();

var controle = reactive({
  clienteId: props.ClienteId as number | null | undefined,
  itens: [] as service.Contrato[],
  listaStatus: [] as service.ContratoStatus[],
  model: {
    clienteId: props.ClienteId
  } as service.Contrato,
  janela: false,
  janPergunta: false,
  erro: "",
  status: "",

  janParcelas: false,
  contratoParcelas: null as service.Contrato | null,
  parcelas: [] as mensalidadesService.Mensalidade[],
  statusParcelas: "",
  erroParcelas: "",

  parcelaEditando: null as mensalidadesService.Mensalidade | null,
  formParcela: {
    dataVencimento: null,
    valor: 0,
    referente: ""
  } as mensalidadesService.MensalidadeAlterarDto,
  statusEdicaoParcela: "",
  erroEdicaoParcela: "",

  janConfirmaPagamento: false,
  parcelaPagando: null as mensalidadesService.Mensalidade | null,
  statusPagamento: "",
  erroPagamento: "",

  janCancelarContrato: false,
  contratoCancelando: null as service.Contrato | null,
  motivoCancelamento: "",
  statusCancelamento: "",
  erroCancelamento: "",

  janGerarParcelas: false,
  formGerarParcelas: {
    dataInicial: null as string | null,
    dataFinal: null as string | null,
  },
  parcelasSimuladas: [] as service.ParcelaSimulada[],
  statusGerarParcelas: "",
  erroGerarParcelas: "",
})

onMounted(() => {

  buscarItems();

});

watch(() => props.ClienteId, (newValue) => {
  controle.clienteId = newValue;
  controle.model.clienteId = newValue ?? 0;
  buscarItems();
});

async function buscarItems() {

  if (!props.ClienteId) {
    controle.itens = [];
    return;
  }

  controle.status = "Buscando items...";
  controle.erro = "";
  service.obterContratosPorCliente(props.ClienteId)
    .then((r) => {
      controle.itens = r;
      controle.status = "";
    })
    .catch((error) => {
      controle.erro = `Erro ao buscar items: ${error}`;
      controle.status = "";
    });
}

async function buscarStatus() {

  controle.status = "Buscando status...";
  controle.erro = "";
  service.obterStatus()
    .then((r) => {
      controle.listaStatus = r;
      controle.status = "";
    })
    .catch((error) => {
      controle.erro = `Erro ao buscar items: ${error}`;
      controle.status = "";
    });
}

async function salvar() {

  controle.status = "Salvando item...";
  controle.erro = "";


  controle.model.clienteId = controle.clienteId ?? 0;

  await service.salvar(controle.model)
    .then(() => {
      controle.status = "";
      controle.model = {
        clienteId: controle.model.clienteId,

      } as service.Contrato;

      buscarItems();
      controle.janela = false;
    })
    .catch((error) => {
      controle.erro = `Erro ao salvar item: ${error}`;
      controle.status = "";
    });
}

function excluir(item: service.Contrato) {
  controle.model = item;
  controle.janPergunta = true;
}

function excluirConfirma() {
  controle.janPergunta = false;
  controle.status = "Excluindo item...";
  controle.erro = "";

  service.excluir(controle.model.contratoId)
    .then(() => {
      controle.status = "";
      controle.model = {
        clienteId: controle.model.clienteId,

      } as service.Contrato;
      buscarItems();
    })
    .catch((error) => {
      controle.erro = `Erro ao excluir item: ${error.message || error}`;
      controle.status = "";
    });
}

function adicionar() {
  controle.model = {
    clienteId: controle.clienteId,
    statusId: 1,

  }
  controle.janela = true;
}

function verParcelas(item: service.Contrato) {
  controle.contratoParcelas = item;
  controle.parcelaEditando = null;
  controle.janParcelas = true;
  buscarParcelas();
}

function buscarParcelas() {
  if (!controle.contratoParcelas?.contratoId) return;

  controle.statusParcelas = "Buscando parcelas...";
  controle.erroParcelas = "";

  mensalidadesService.obterPorContrato(controle.contratoParcelas.contratoId)
    .then((r) => {
      controle.parcelas = r;
      controle.statusParcelas = "";
    })
    .catch((error) => {
      controle.erroParcelas = `Erro ao buscar parcelas: ${error.message || error}`;
      controle.statusParcelas = "";
    });
}

function editarParcela(parcela: mensalidadesService.Mensalidade) {
  controle.parcelaEditando = parcela;
  controle.formParcela = {
    dataVencimento: parcela.dataVencimento ? fdataUS(parcela.dataVencimento) : null,
    valor: parcela.valor,
    referente: parcela.referente
  };
  controle.erroEdicaoParcela = "";
}

function cancelarEdicaoParcela() {
  controle.parcelaEditando = null;
}

function abrirBoleto(boletoId: number) {
  window.open(`${config.urlApi}/Boletos/Ver/${boletoId}`, '_blank');
}

function confirmarPagamento(item: mensalidadesService.Mensalidade) {
  controle.parcelaPagando = item;
  controle.erroPagamento = "";
  controle.janConfirmaPagamento = true;
}

function pagarConfirmado() {
  if (!controle.parcelaPagando) return;

  controle.statusPagamento = "Registrando pagamento...";
  controle.erroPagamento = "";

  mensalidadesService.pagar(controle.parcelaPagando.id)
    .then(() => {
      controle.statusPagamento = "";
      controle.parcelaPagando = null;
      buscarParcelas();
    })
    .catch((error) => {
      controle.erroPagamento = `Erro ao registrar pagamento: ${error.message || error}`;
      controle.statusPagamento = "";
    });
}

function salvarParcela() {
  if (!controle.parcelaEditando) return;

  controle.statusEdicaoParcela = "Salvando...";
  controle.erroEdicaoParcela = "";

  mensalidadesService.alterar(controle.parcelaEditando.id, controle.formParcela)
    .then(() => {
      controle.statusEdicaoParcela = "";
      controle.parcelaEditando = null;
      buscarParcelas();
    })
    .catch((error) => {
      controle.erroEdicaoParcela = `Erro ao salvar parcela: ${error.message || error}`;
      controle.statusEdicaoParcela = "";
    });
}

function abrirCancelarContrato(item: service.Contrato) {
  controle.contratoCancelando = item;
  controle.motivoCancelamento = "";
  controle.erroCancelamento = "";
  controle.statusCancelamento = "";
  controle.janCancelarContrato = true;
}

function cancelarContratoConfirmado() {
  if (!controle.contratoCancelando) return;

  controle.statusCancelamento = "Cancelando contrato...";
  controle.erroCancelamento = "";

  service.cancelarContrato(controle.contratoCancelando.contratoId, controle.motivoCancelamento || null)
    .then(() => {
      controle.statusCancelamento = "";
      controle.janCancelarContrato = false;
      controle.contratoCancelando = null;
      buscarItems();
    })
    .catch((error) => {
      controle.erroCancelamento = `Erro ao cancelar contrato: ${error.message || error}`;
      controle.statusCancelamento = "";
    });
}

function abrirGerarParcelas() {
  controle.parcelasSimuladas = [];
  controle.erroGerarParcelas = "";
  controle.statusGerarParcelas = "";

  paramsService.obter()
    .then((r) => {
      const dia = r?.[0]?.diaVencimentoBoleto ?? 10;

      const hoje = new Date();
      const inicial = new Date(hoje.getFullYear(), hoje.getMonth() + 1, dia);

      controle.formGerarParcelas.dataInicial = fdataUS(inicial);
    });

  controle.janGerarParcelas = true;
}

watch(() => controle.formGerarParcelas.dataInicial, (novoValor) => {
  if (!novoValor) return;

  const inicial = isoParaData(novoValor);
  if (!inicial) return;

  //12 parcelas ao todo: a informada + mais 11, uma por mes
  const final = new Date(inicial.getFullYear(), inicial.getMonth() + 11, inicial.getDate());
  controle.formGerarParcelas.dataFinal = fdataUS(final);
});

function verParcelasSimuladas() {
  if (!controle.contratoParcelas?.contratoId) return;
  if (!controle.formGerarParcelas.dataInicial || !controle.formGerarParcelas.dataFinal) return;

  controle.statusGerarParcelas = "Calculando...";
  controle.erroGerarParcelas = "";
  controle.parcelasSimuladas = [];

  service.simularParcelas(controle.contratoParcelas.contratoId, controle.formGerarParcelas.dataInicial, controle.formGerarParcelas.dataFinal)
    .then((r) => {
      controle.parcelasSimuladas = r.map((item) => ({ ...item, dataVencimento: fdataUS(item.dataVencimento) }));
      controle.statusGerarParcelas = "";
    })
    .catch((error) => {
      controle.erroGerarParcelas = `Erro ao calcular parcelas: ${error.message || error}`;
      controle.statusGerarParcelas = "";
    });
}

function gerarParcelasConfirmado() {
  if (!controle.contratoParcelas?.contratoId || controle.parcelasSimuladas.length == 0) return;

  controle.statusGerarParcelas = "Gerando parcelas...";
  controle.erroGerarParcelas = "";

  service.gerarParcelas(controle.contratoParcelas.contratoId, controle.parcelasSimuladas)
    .then(() => {
      controle.statusGerarParcelas = "";
      controle.janGerarParcelas = false;
      controle.parcelasSimuladas = [];
      buscarParcelas();
    })
    .catch((error) => {
      controle.erroGerarParcelas = `Erro ao gerar parcelas: ${error.message || error}`;
      controle.statusGerarParcelas = "";
    });
}
</script>

<template>
  <TrataTecla>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
      <div class="card-header">
        <h5 class="card-title">Contratos / Planos</h5>
      </div>
      <div class="card-body p-3" v-if="!props.ClienteId">
        <div class="row mb-2">
          <div class="col-md-12">
            <p class="">Necessário cadastro do cliente</p>
          </div>
        </div>
      </div>
      
      <div class="card-body p-3" v-else>
        <div class="row mb-2">
          <div class="col-md-6">
            <a class="btn btn-sm btn-primary " @click="adicionar()">Adicionar</a>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-md-12 table-responsive">
            <table class="table table-sm table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>Contrato</th>
                  <th>Vendedor</th>
                  <th>Plano</th>
                  <th>Status</th>
                  <th>Pré contrato</th>
                  <th>Dt. Inicio</th>
                  <th>Dt. Fim</th>
                  <th>Dt. Assinatura</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="controle.itens.length == 0">
                  <tr>
                    <td colspan="9" class="text-center">Nenhum registro</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(item, index) in controle.itens" :key="index">
                    <td>{{ item.contratoId }}</td>
                    <td>{{ item.vendedor?.nomeCompleto }}</td>
                    <td>{{ item.plano?.nome }}</td>
                    <td>{{ item.status?.descricao }}</td>
                    <td>{{ item.preContrato }}</td>
                    <td>{{ fdata(item.dataInicio) }}</td>
                    <td>{{ fdata(item.dataFim) }}</td>
                    <td>{{ fdata(item.dataAssinatura) }}</td>
                    <td>
                      <a class="me-2" title="Ver parcelas" href="#" @click.prevent="verParcelas(item)">
                        <i class="flaticon-money text-primary fs-5"></i>
                      </a>

                      <a class="" title="Alterar registro" href="#"
                        @click="controle.model = item; controle.janela = true"
                        v-if="acl.can('supervisor') || acl.can('admin')">
                        <i class="flaticon-edit text-primary fs-5"></i>
                      </a>

                      <a class="ms-2" title="Cancelar contrato" href="#" @click.prevent="abrirCancelarContrato(item)"
                        v-if="item.statusId != 3 && (acl.can('supervisor') || acl.can('admin'))">
                        <i class="fa fa-ban text-warning fs-5"></i>
                      </a>

                      <a class="ms-2" title="Excluir registro" href="#" @click="excluir(item)"
                        v-if="acl.can('supervisor') || acl.can('admin')">
                        <i class="flaticon-delete text-danger fs-5"></i>
                      </a>

                      <RouterLink class="ms-2" title="Ver o contrato"
                        :to="{ name: 'contratosVer', params: { id: item.contratoId } }">
                        <i class="flaticon-search text-primary fs-5"></i>
                      </RouterLink>

                      <RouterLink class="ms-2" title="Assinar o contrato" v-if="item.dataAssinatura == null"
                        :to="{ name: 'contratosAssinar', params: { id: item.contratoId } }">
                        <i class="flaticon-pen text-primary fs-5"></i>
                      </RouterLink>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <p class="">Registros: {{ controle.itens.length }}</p>
          </div>
        </div>
        <div class="text-center">
          <span class="">{{ controle.status }}</span>
          <span class="text-danger fw-bold">{{ controle.erro }}</span>
        </div>
      </div>
    </div>
  </TrataTecla>

  <TrataTecla>
    <MsgBox :id="'janAddContratos'" class="modal-md" data-bs-backdrop="static" :exibir="controle.janela"
      :titulo="'Contrato do ciente'" @on-fechou="controle.janela = false" :botao-gravar="true" :botao-fechar="true"
      @on-gravar="salvar()">

      <div class="row mb-2">
        <div class="col-md-3">
          Pré contrato
        </div>
        <div class="col-md-4">
          <DropdownSimNao v-model="controle.model.preContrato" class="form-select form-select-sm" />
        </div>
      </div>

      <div class="row mb-2" v-if="controle.model.preContrato == true">
        <div class="col-md-3">
          Vencimento 1º Boleto
        </div>
        <div class="col-md-4">
          <input type="date" class="form-control form-control-sm" :value="fdataUS(controle.model.dataPriParcela)" />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-3">
          Plano
        </div>
        <div class="col-md-9">
          <DropdownPlanos v-model="controle.model.planoId" class="form-select form-select-sm"
            @selected="(plano) => controle.model.plano = plano" />
        </div>
      </div>

      <div class="row mb-2" v-if="controle.model.planoId > 0">
        <div class="col-md-3">

        </div>
        <div class="col-md-9">
          <RouterLink class="btn btn-sm btn-primary" title="Ler o contrato" target="_blank"
            :to="{ name: 'planosLer', params: { id: controle.model.planoId } }">
            <i class="flaticon-search"></i> Ler o contrato
          </RouterLink>
        </div>
      </div>

      <template v-if="controle.model.plano">
        <div class="row mb-2">
          <div class="col-md-3">
            Idade Mínima
          </div>
          <div class="col-md-3">
            <TextBox :model-value="controle.model.plano.idadeMinima" readonly disabled class="text-end" />
          </div>
          <div class="col-md-2">
            Idade Máxima
          </div>
          <div class="col-md-3">
            <TextBox :model-value="controle.model.plano.idadeMaxima" readonly disabled class="text-end" />
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-md-3">
            Máximo de Pessoas
          </div>
          <div class="col-md-3">
            <TextBox :model-value="controle.model.plano.maximoPessoas" readonly disabled class="text-end" />
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-md-3">
            Valor R$
          </div>
          <div class="col-md-3">
            <TextBox :model-value="controle.model.plano.valor" :formato="'DoisDecimais'" readonly disabled class="text-end" />
          </div>
          <div class="col-md-2">
            Valor com Seguro R$
          </div>
          <div class="col-md-3">
            <TextBox :model-value="controle.model.plano.valorComSeguro" :formato="'DoisDecimais'" readonly disabled class="text-end" />
          </div>
        </div>

        <div class="row mb-2" v-if="controle.model.plano.permiteSeguro">
          <div class="col-md-3">
            Com Seguro?
          </div>
          <div class="col-md-4">
            <DropdownSimNao v-model="controle.model.comSeguro" class="form-select form-select-sm" />
          </div>
        </div>
      </template>

      <div class="row mb-2">
        <div class="col-md-3">
          Vendedor
        </div>
        <div class="col-md-9">
          <DropdownVendedores v-model="controle.model.vendedorId" />
        </div>
      </div>

      <div class="row mb-2" v-if="controle.model?.contratoId > 0">
        <div class="col-md-3">
          Status
        </div>
        <div class="col-md-9">
          <DropdownContratosStatus v-model="controle.model.statusId" />
        </div>
      </div>

      <div class="row mb-2" v-if="controle.model?.contratoId > 0">
        <div class="col-md-3">
          Dt Inicio
        </div>
        <div class="col-md-4">
          <input type="date" class="form-control form-control-sm" :value="fdataUS(controle.model.dataInicio)"
            @change="controle.model.dataInicio = $event.target.value" />
        </div>
      </div>

      <div class="row mb-2" v-if="controle.model?.contratoId > 0">
        <div class="col-md-3">
          Dt Fim
        </div>
        <div class="col-md-4">
          <input type="date" class="form-control form-control-sm" :value="fdataUS(controle.model.dataFim)"
            @change="controle.model.dataFim = $event.target.value" />
        </div>
      </div>

    </MsgBox>
  </TrataTecla>

  <MsgBox :id="'janPerguntaContrato'" class="modal-md" data-bs-backdrop="static" :exibir="controle.janPergunta"
    :titulo="'Atenção'" @on-fechou="controle.janPergunta = false" :botao-sim="true" :botao-nao="true"
    @on-sim="excluirConfirma()">
    <div class="row mb-2">
      <div class="col-md-12 fs-5 fw-bold text-center ">
        Deseja excluir este registro ?
      </div>
    </div>
  </MsgBox>

  <MsgBox :id="'janParcelas'" tamanho="modal-lg" data-bs-backdrop="static" :exibir="controle.janParcelas"
    :titulo="'Parcelas do Contrato ' + (controle.contratoParcelas?.contratoId ?? '')"
    @on-fechou="controle.janParcelas = false; controle.parcelaEditando = null" :botao-fechar="true">

    <template v-if="controle.parcelaEditando == null">
      <div class="row mb-2" v-if="controle.contratoParcelas?.statusId != 3">
        <div class="col-md-12">
          <a class="btn btn-sm btn-success" href="#" @click.prevent="abrirGerarParcelas()">
            <i class="fa fa-plus"></i> Gerar Parcelas
          </a>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-sm table-striped table-bordered table-hover">
          <thead>
            <tr>
              <th>Parcela</th>
              <th>Referente</th>
              <th>Vencimento</th>
              <th>Valor</th>
              <th>Pagamento</th>
              <th>Valor Pago</th>
              <th>Boleto</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="controle.parcelas.length == 0">
              <td colspan="8" class="text-center">Nenhuma parcela encontrada</td>
            </tr>
            <tr v-for="item in controle.parcelas" :key="item.id">
              <td>{{ item.parcela }}</td>
              <td>{{ item.referente }}</td>
              <td>{{ fdata(item.dataVencimento) }}</td>
              <td class="text-end">{{ f2dec(item.valor) }}</td>
              <td>{{ fdata(item.dataPagamento) }}</td>
              <td class="text-end">{{ f2dec(item.valorPago) }}</td>
              <td>{{ item.boletoId ?? '-' }}</td>
              <td class="text-nowrap" v-if="item.statusId == 6">
                <span class="badge bg-secondary">Cancelada</span>
              </td>
              <td class="text-nowrap" v-else>
                <a v-if="item.boletoId == null && item.dataPagamento == null" class="btn btn-sm btn-primary me-1"
                  title="Alterar parcela" href="#" @click.prevent="editarParcela(item)">
                  <i class="flaticon-edit"></i>
                </a>
                <span v-else class="text-muted me-1"
                  :title="item.dataPagamento != null ? 'Parcela já paga, não é possível alterar' : 'Parcela já tem boleto gerado, não é possível alterar'">
                  <i class="flaticon-lock"></i>
                </span>

                <a v-if="item.boletoId != null" class="btn btn-sm btn-warning me-1"
                  title="Imprimir boleto" href="#" @click.prevent="abrirBoleto(item.boletoId)">
                  <i class="fa fa-print"></i>
                </a>

                <a v-if="item.dataPagamento == null" class="btn btn-sm btn-success"
                  title="Pagar" href="#" @click.prevent="confirmarPagamento(item)">
                  <i class="fa fa-check"></i> Pagar
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-center">
        <span class="">{{ controle.statusParcelas }}</span>
        <span class="text-danger fw-bold">{{ controle.erroParcelas }}</span>
      </div>
    </template>

    <template v-else>
      <div class="row mb-2">
        <div class="col-md-12">
          Parcela {{ controle.parcelaEditando.parcela }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-3">
          Vencimento
        </div>
        <div class="col-md-9">
          <input type="date" class="form-control form-control-sm" v-model="controle.formParcela.dataVencimento" />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-3">
          Valor R$
        </div>
        <div class="col-md-9">
          <TextBox v-model="controle.formParcela.valor" :formato="'DoisDecimais'" class="text-end" />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-3">
          Referente
        </div>
        <div class="col-md-9">
          <TextBox v-model="controle.formParcela.referente" />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-12 text-center">
          <span class="">{{ controle.statusEdicaoParcela }}</span>
          <span class="text-danger fw-bold">{{ controle.erroEdicaoParcela }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <a class="btn btn-sm btn-primary me-2" @click="salvarParcela()">
            <i class="fa fa-save"></i> Gravar
          </a>
          <a class="btn btn-sm btn-secondary" @click="cancelarEdicaoParcela()">
            <i class="fa fa-times"></i> Cancelar
          </a>
        </div>
      </div>
    </template>

  </MsgBox>

  <MsgBox :id="'janCancelarContrato'" class="modal-md" data-bs-backdrop="static" :exibir="controle.janCancelarContrato"
    :titulo="'Cancelar contrato ' + (controle.contratoCancelando?.contratoId ?? '')"
    @on-fechou="controle.janCancelarContrato = false" :botao-sim="true" :botao-nao="true"
    @on-sim="cancelarContratoConfirmado()">
    <div class="row mb-2">
      <div class="col-md-12 fw-bold text-center">
        Deseja cancelar este contrato?
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12 small text-muted">
        As parcelas em aberto serão canceladas e não serão mais geradas parcelas nem boletos. Parcelas pagas e
        parcelas com boleto já enviado/registrado no banco são mantidas.
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-3">
        Motivo
      </div>
      <div class="col-md-9">
        <textarea class="form-control form-control-sm" rows="3" maxlength="500"
          v-model="controle.motivoCancelamento"></textarea>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <span class="">{{ controle.statusCancelamento }}</span>
        <span class="text-danger fw-bold">{{ controle.erroCancelamento }}</span>
      </div>
    </div>
  </MsgBox>

  <MsgBox :id="'janGerarParcelas'" tamanho="modal-lg" data-bs-backdrop="static" :exibir="controle.janGerarParcelas"
    :titulo="'Gerar Parcelas'" @on-fechou="controle.janGerarParcelas = false; controle.parcelasSimuladas = []"
    :botao-fechar="true">

    <div class="row mb-2">
      <div class="col-md-3">
        Data Inicial
      </div>
      <div class="col-md-4">
        <input type="date" class="form-control form-control-sm" v-model="controle.formGerarParcelas.dataInicial" />
      </div>
      <div class="col-md-2">
        Data Final
      </div>
      <div class="col-md-3">
        <input type="date" class="form-control form-control-sm" v-model="controle.formGerarParcelas.dataFinal" />
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-12">
        <a class="btn btn-sm btn-primary" href="#" @click.prevent="verParcelasSimuladas()">
          <i class="fa fa-search"></i> Ver
        </a>
      </div>
    </div>

    <div class="row mb-2" v-if="controle.parcelasSimuladas.length > 0">
      <div class="col-md-12 table-responsive">
        <table class="table table-sm table-striped table-bordered">
          <thead>
            <tr>
              <th>Parcela</th>
              <th>Data Vencimento</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in controle.parcelasSimuladas" :key="index">
              <td>{{ item.parcela }}</td>
              <td>
                <input type="date" class="form-control form-control-sm" v-model="item.dataVencimento" />
              </td>
              <td class="text-end">{{ f2dec(item.valor) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-12 text-center">
        <span class="">{{ controle.statusGerarParcelas }}</span>
        <span class="text-danger fw-bold">{{ controle.erroGerarParcelas }}</span>
      </div>
    </div>

    <div class="row" v-if="controle.parcelasSimuladas.length > 0">
      <div class="col-md-12">
        <a class="btn btn-sm btn-success" href="#" @click.prevent="gerarParcelasConfirmado()">
          <i class="fa fa-save"></i> Gerar {{ controle.parcelasSimuladas.length }} Parcela(s)
        </a>
      </div>
    </div>

  </MsgBox>

  <MsgBox :id="'janConfirmaPagamentoParcela'" class="modal-md" data-bs-backdrop="static"
    :exibir="controle.janConfirmaPagamento" :titulo="'Atenção'"
    @on-fechou="controle.janConfirmaPagamento = false; controle.parcelaPagando = null" :botao-sim="true"
    :botao-nao="true" @on-sim="pagarConfirmado()">
    <div class="row mb-2">
      <div class="col-md-12 fs-5 fw-bold text-center ">
        Confirma o pagamento?
      </div>
    </div>
    <div class="row" v-if="controle.parcelaPagando">
      <div class="col-md-12 text-center">
        Parcela {{ controle.parcelaPagando.parcela }} - R$ {{ f2dec(controle.parcelaPagando.valor) }}
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 text-center">
        <span class="">{{ controle.statusPagamento }}</span>
        <span class="text-danger fw-bold">{{ controle.erroPagamento }}</span>
      </div>
    </div>
  </MsgBox>

</template>

<style lang="css" scoped>
a {
  text-decoration: none;
}
</style>